module.exports = __webpack_public_path__ + "static/img/HY-S1.7aa7ffc7.png";